import HeaderTitleContent from '../../../common/components/atom/HeaderTitleContent/HeaderTitleContent'
import PageContent from '../../../common/components/atom/PageContent/PageContent'
import SectionTitle from '../../../common/components/atom/SectionTitle/SectionTitle'
import ClientList from '../../../features/clients/components/ClientsList'

export default function ClientListPage() {
  return (
    <PageContent>
      <HeaderTitleContent >
        Clients
      </HeaderTitleContent>
      <div style={{ padding: '20px' }}/>
      <SectionTitle iconType="people-star">Liste des clients</SectionTitle>
      <ClientList.ListClientExtend />
    </PageContent>
  )
}
